export default __webpack_public_path__ + "static/s4-9ad457c157b559416a8f0941083b80b2.jpg";